<template>
  <div class="authorization">

    <div class="authorization-content row">
      <div class="col-12 authorization-content-card">
        <div class="row justify-content-center ">
          <div class="col-10 col-md-8 col-lg-6 col-xl-5">
            <div class="card shadow">
              <div class="card-header text-center">
                <h5 v-text="$t('messages.accountAuthorization')"></h5>
              </div>
              <div class="card-body authorization-content-message d-flex flex-column justify-content-between">
                <p class="my-3 text-center" v-html="$t('messages.alreadyAccount')"></p>
                <div class="row justify-content-center">
                  <div class="col-auto">
                    <div class="rounded-pill border bg-black text-white py-1 px-3">
                      <p class=" f-18 text-center">
                        <i class="fa fa-user-circle fa-lg mr-2"></i>
                        <strong v-text="$route.query.email"> </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row justify-content-center">
                  <div class="col-6 col-lg-4">
                    <b-button variant="light w-100 "
                      :to="{ path: '/accounts/signup', query: { site_id: $route.query.site_id, to: $route.query.to }}"
                      v-text="$t('dashboard.payments.newAccount')">
                    </b-button>
                  </div>
                  <div class="col-6 col-lg-4">
                    <b-button variant="success w-100 " @click="fnApiAuthorizationAccount()"
                      v-text="$t('general.continue')">
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        account: {
          account: null,
          siteId: null,
          to: null,
        }
      }
    },
    methods: {
      fnApiAuthorizationAccount() {
        if (('site_id' in this.$route.query) && ('account' in this.$route.query) && ('to' in this.$route.query)) {
          delete this.$route.query.email;
          this.$route.query.auth = true;
          axiosAccount.post('login/existing', this.$route.query).then((response) => {
            window.location.replace(response.data);
          }).catch(() => {});
        } else {
          alert('Miss information');
        }
      }
    },
  }
</script>

<style lang="scss">
  .authorization {
    background-color: gray;
    padding-top: 25vh;

    .authorization-content {
      min-height: 75vh;
      background-color: white;

      .authorization-content-card {
        transform: translateY(-10vh);
      }

      .authorization-content-message {
        min-height: 25vh;
      }

    }

  }
</style>